/**
 *  위젯을 선택해주세요.
 */
export const INVALID_REQUIRED_SELECT_WIDGET_MESSAGE = '위젯을 선택해주세요.';
